import splitBreakpoints from '../split-breakpoints'

function parseColor (color) {
  return { color }
}

export default splitBreakpoints(parseColor)
